module.exports = __webpack_public_path__ + "img/bg-newclip.18a9a99a.jpg";